import { Primary, Text } from '@cinch-labs/design-system'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import { useRouter } from 'next/router'

import { supportContactContent } from '../../data/content'
import { handleTrackingClick } from '../../helpers/helpers'
import styles from './support-pre-footer.module.css'

const SupportPreFooter = () => {
  const router = useRouter()
  const { trackEvent } = useAnalytics()
  const { footerCta, footerHeading } = supportContactContent

  return (
    <>
      <section className={styles.ctaContainer}>
        <div className={styles.textWrapper}>
          <Text element="h2" fontSize="m" fontWeight="semibold">
            {footerHeading}
          </Text>
        </div>
        <Primary
          onClick={() => {
            handleTrackingClick(trackEvent, {
              eventName: 'click',
              category: 'button',
              label: footerCta,
            })
            router.push('/used-cars')
          }}
        >
          {footerCta}
        </Primary>
      </section>
    </>
  )
}

export default SupportPreFooter
